import { render, staticRenderFns } from "./CmFrotasPieChart.vue?vue&type=template&id=1c0f311f&"
import script from "./CmFrotasPieChart.vue?vue&type=script&lang=js&"
export * from "./CmFrotasPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports